export default __webpack_public_path__ + "static/media/MoroccoImg2.1ce75ca8.jpg";